// export const URL_API = "http://127.0.0.1:8000";
export const URL_API = "https://api.dashboard.ekles-clinic.com";
